export default __webpack_public_path__ + "static/media/downloadchplay.fe84a50f.png";